import { OptionDescription } from './option.type';
import { ERecruitmentType, ERecruitmentStatus, ERecruitmentDivision } from '../enums/recruitment.enum';

export type RecruitmentTypeRecord = Record<ERecruitmentType, OptionDescription<ERecruitmentType>>;
export type RecruitmentStatusRecord = Record<ERecruitmentStatus, OptionDescription<ERecruitmentStatus> & { viewClass: string; viewStatus: string }>;
export type RecruitmentDivisionRecord = Record<ERecruitmentDivision, OptionDescription<ERecruitmentDivision>>;
